import { Button } from '../../../../common/html/button'

export const Cancel = ({ onCancel }) => {
  const handleCancel = () => {
    onCancel && onCancel()
  }

  return (
    <Button
      label="common.CANCEL"
      style={{
        border: '1px solid #D5D5D5',
        backgroundColor: '#FFFFFF',
        color: false ? '#9C9C9C' : '#3a414b',
      }}
      disabled={false}
      action={handleCancel}
      isI18n
    />
  )
}
